import VueCookie from 'vue-cookie'
// configs
import configs from '@/config'
import util from '@/util'

const initOptions = {
  expires: 365,
  sameSite: 'none',
  secure: true,
}

const otherRegions = ['eu']

const transformKey = (key) => {
  if (!key) return key

  let prefix = ''

  if (otherRegions.includes(configs.region)) {
    prefix += `${configs.region}-`
  }

  if (prefix) {
    return prefix + key
  }

  return key
}

const _getRootDomain = (domain) => {
  if (!util.checkWhiteLabelDomain() || configs.env !== 'local') {
    const parts = domain.split('.')

    return parts.slice(-2).join('.')
  }

  return domain
}

const setValueByDomain = (key, value, options = initOptions) => {
  if (!window.location.hostname.includes(configs.domain)) return

  if (configs.domain === 'ahaslides.eu') return

  const newOptions = {
    ...options,
    domain: configs.domain,
  }

  const newKey = transformKey(key)
  VueCookie.set(newKey, value || '', newOptions)
}

const setValue = (key, value, options = initOptions) => {
  const newKey = transformKey(key)

  VueCookie.set(newKey, value || '', options)
}

const getValue = (key) => {
  const newKey = transformKey(key)
  const value = VueCookie.get(newKey)

  if (value === 'true') {
    return true
  }

  if (value === 'false') {
    return false
  }

  return value
}

const deleteValue = (key) => {
  const newKey = transformKey(key)
  VueCookie.delete(newKey)

  if (window.location.hostname.includes(configs.domain)) {
    VueCookie.delete(newKey, {
      domain: configs.domain,
    })
  }
}

const setTokenValue = (key, value, options = initOptions) => {
  if (util.isEuOrWhiteLabel()) {
    setValue(key, value, options)

    return
  }

  const newKey = transformKey(key)

  VueCookie.set(newKey, value, {
    ...options,
    domain: _getRootDomain(configs.domain),
    path: '/',
  })
}

const deleteTokenValue = (key = 'ahaToken') => {
  const newKey = transformKey(key)
  deleteValue(newKey)

  if (util.isEuOrWhiteLabel()) return

  VueCookie.delete(newKey, {
    domain: _getRootDomain(configs.domain),
    path: '/',
  })
}

const deleteRootDomainValue = (key) => {
  const rootDomain = window.location.hostname.includes('localhost')
    ? 'localhost'
    : _getRootDomain(configs.domain)
  const newKey = transformKey(key)
  VueCookie.delete(newKey, {
    domain: rootDomain,
  })
}

export default {
  deleteValue,
  setValue,
  setValueByDomain,
  getValue,
  setTokenValue,
  deleteTokenValue,
  deleteRootDomainValue,
}
